import React, { useEffect } from 'react'
import './yandex-map.scss'

const YandexMap = ({ yandexMapRef, initCallback, mapExists }) => {
    useEffect(() => {
        if (mapExists) 
            return
        initMapLibrary(initCallback)
    }, [initCallback, mapExists])

    const initMapLibrary = (callback) => {
        const mapScriptIsLoaded = function () {
            setTimeout(function () {
                window.ymaps.ready(function () {
                    callback()
                })
            }, 20)
        }

        if (window.ymaps) {
            mapScriptIsLoaded()
            return
        }

        const scriptTag = document.createElement('script')
        scriptTag.type = 'text/javascript'
        scriptTag.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=a14a859d-ebfd-4080-a8a7-5d925a3d9f21&load=package.standard&onload=getYandexMap&width=100%&height=450'

        scriptTag.onload = function () {
            mapScriptIsLoaded()
        }

        document.getElementsByTagName('body')[0].appendChild(scriptTag);
    }

    return <div ref={yandexMapRef} className='yandex-map'/>
}

export {YandexMap}
